import React from 'react';

const Hashtag = ({ width = 20, height = 20, color = 'var(--icon-default)', ...rest }, ref) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <line
        x1="0.625"
        y1="-0.625"
        x2="17.3138"
        y2="-0.625"
        transform="matrix(-0.319267 0.947665 -0.893256 -0.449547 8.72729 1.5)"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <line
        x1="0.625"
        y1="-0.625"
        x2="17.3138"
        y2="-0.625"
        transform="matrix(-0.319267 0.947665 -0.893256 -0.449547 16.4546 1.5)"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <line x1="2.625" y1="6.875" x2="19.375" y2="6.875" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <line x1="1.625" y1="12.875" x2="18.375" y2="12.875" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(Hashtag);
